import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBestSellerById } from "../services/customizerAPI";
import axiosClient from "../services/apiClient";

export interface IGetBestSellerProductPayload {
  id: string;
  data?: {
    size: string | number;
    engraving?: string;
    subpath: string;
  }
}

export interface IAddBestSellerToCartPayload {
  protection_plan?: 1 | 0,
  forever_box?: 1 | 0;
  data: {
    size: number,
    bestseller_id: string,
    engraving: string,
    subpath: string,
    summaryContent: any,
    intergration_url: string,
    ring_url?: string,
    magic_number?: string,
  }
}

export const getBestSellerProduct = createAsyncThunk('lashbrook/getBestSellerProduct',
  async (payload: IGetBestSellerProductPayload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await getBestSellerById(payload.id, payload.data);
      return fulfillWithValue(res.data)
    } catch (error) {
      return rejectWithValue(error);
    }
  });

export const addBestSellerToCart = createAsyncThunk('lashbrook/addToCart',
  async ({ data }: IAddBestSellerToCartPayload, { fulfillWithValue, rejectWithValue }) => {
    try {
      const res = await axiosClient.post(`/api/v2/addBestSellerToCart`, data, {
        headers: {
          'subpath': data.subpath,
        }
      });
      return fulfillWithValue(res.data)
    } catch (error) {
      return rejectWithValue(error);
    }
  });